import { Reducer } from 'redux';
import { types } from './UserActions';
import { IUserState, IUserAction } from '../../common/model/UserModels';

export const userReducer: Reducer<IUserState, IUserAction> = (
    state: IUserState = { currentUser: {} },
    action: IUserAction
) => {
    switch (action.type) {
        // USER STORE
        case types.GET_USER_REQUEST: {
            return {
                ...state,
                currentUserLoading: true,
            };
        }
        case types.GET_USER_SUCCESS: {
            return {
                ...state,
                currentUserLoading: false,
                currentUser: action.payload?.userData,
            };
        }
        case types.GET_USER_FAILURE: {
            return {
                ...state,
                currentUserLoading: false,
                currentUserError: action.error,
            };
        }
        case types.GET_USER_CONFIG_REQUEST: {
            return {
                ...state,
                currentUserConfigLoading: true,
            };
        }
        case types.GET_USER_CONFIG_SUCCESS: {
            return {
                ...state,
                currentUserConfigLoading: false,
                currentUserConfig: action.payload?.userData,
            };
        }
        case types.GET_USER_CONFIG_FAILURE: {
            return {
                ...state,
                currentUserConfigLoading: false,
                currentUserConfigError: action.error,
            };
        }
        case types.UPDATE_USER_REQUEST: {
            return {
                ...state,
                updateUserLoading: true,
            };
        }
        case types.UPDATE_USER_SUCCESS: {
            return {
                ...state,
                updateUserLoading: false,
                currentUser: {
                    ...action.payload?.userData,
                    userConfiguration: !action.payload?.userData
                        .userConfiguration
                        ? state.currentUser.userConfiguration
                        : action.payload?.userData.userConfiguration,
                },
            };
        }
        case types.UPDATE_USER_FAILURE: {
            return {
                ...state,
                updateUserLoading: false,
                currentUserError: action.error,
            };
        }

        case types.UPDATE_USER_CONFIG_REQUEST: {
            return {
                ...state,
                updateUserConfigLoading: true,
            };
        }
        case types.UPDATE_USER_CONFIG_SUCCESS: {
            return {
                ...state,
                updateUserConfigLoading: false,
                currentUserConfig: action.payload?.userData,
            };
        }
        case types.UPDATE_USER_CONFIG_FAILURE: {
            return {
                ...state,
                updateUserConfigLoading: false,
                currentUserConfigError: action.error,
            };
        }

        case types.GET_PICTURE_REQUEST: {
            return {
                ...state,
                getPictureLoading: true,
            };
        }

        case types.GET_PICTURE_SUCCESS: {
            return {
                ...state,
                getPictureLoading: false,
                currentUserPicture: action.payload,
            };
        }

        case types.GET_PICTURE_FAILURE: {
            return {
                ...state,
                getPictureLoading: false,
                currentUserPicture: action.error,
            };
        }

        case types.UPDATE_PICTURE_REQUEST: {
            return {
                ...state,
                updatePictureLoading: true,
            };
        }
        case types.UPDATE_PICTURE_SUCCESS: {
            return {
                ...state,
                updatePictureLoading: false,
                currentUserPicture: action.payload,
            };
        }

        case types.UPDATE_PICTURE_FAILURE: {
            return {
                ...state,
                updatePictureLoading: false,
                currentUserPicture: action.error,
            };
        }

        default:
            return state;
    }
};
